import { ReactComponent as AWSS3Icon } from '../../icons/aws-s3.svg';
import { ReactComponent as CloseIcon } from '../../icons/close.svg';
import { ReactComponent as DropdownArrowDownIcon } from '../../icons/dropdown-arrow-down.svg';
import { ReactComponent as EditIcon } from '../../icons/edit.svg';
import { ReactComponent as EnvelopeIcon } from '../../icons/envelope.svg';
import { ReactComponent as FacebookIcon } from '../../icons/facebook.svg';
import { ReactComponent as FloppyDiscIcon } from '../../icons/floppy-disc.svg';
import { ReactComponent as OkIcon } from '../../icons/ok.svg';
import { ReactComponent as OpenWindowIcon } from '../../icons/open-window.svg';
import { ReactComponent as LinkedinIcon } from '../../icons/linkedin.svg';
import { ReactComponent as PaperPlaneIcon } from '../../icons/paperplane.svg';
import { ReactComponent as PersonIcon } from '../../icons/person.svg';
import { ReactComponent as RedditIcon } from '../../icons/reddit.svg';
import { ReactComponent as ShareChainIcon } from '../../icons/share_chain.svg';
import { ReactComponent as TransparentEnvelopeIcon } from '../../icons/envelope-transparent.svg';
import { ReactComponent as TwitterIcon } from '../../icons/twitter.svg';
import { ReactComponent as VerticalDotsIcon } from '../../icons/vertical-dots.svg';
// New icons
import { ReactComponent as QuestionIcon } from '../../newIcons/question.svg';
import { ReactComponent as ArrowSmallLeftIcon } from '../../newIcons/arrow-small-left.svg';
import { ReactComponent as ArrowSmallRightIcon } from '../../newIcons/arrow-small-right.svg';
import { ReactComponent as BarChartIcon } from '../../newIcons/bar-chart.svg';
import { ReactComponent as BookOpenIcon } from '../../newIcons/book-open.svg';
import { ReactComponent as CheckIcon } from '../../newIcons/check.svg';
import { ReactComponent as CheckCircleIcon } from '../../newIcons/check-circle.svg';
import { ReactComponent as CheckboxSelectedIcon } from '../../newIcons/checkbox-selected.svg';
import { ReactComponent as CheckboxUnselectedIcon } from '../../newIcons/checkbox-unselected.svg';
import { ReactComponent as CloseCircleIcon } from '../../newIcons/close-circle.svg';
import { ReactComponent as CompassIcon } from '../../newIcons/compass.svg';
import { ReactComponent as DashboardIcon } from '../../newIcons/dashboard.svg';
import { ReactComponent as DragReorderIcon } from '../../newIcons/drag-reorder.svg';
import { ReactComponent as DocumentIcon } from '../../newIcons/document.svg';
import { ReactComponent as FloppyIcon } from '../../newIcons/floppy.svg';
import { ReactComponent as PenIcon } from '../../newIcons/pen.svg';
import { ReactComponent as PlaceholderIcon } from '../../newIcons/placeholder.svg';
import { ReactComponent as PlusIcon } from '../../newIcons/plus.svg';
import { ReactComponent as PlusSmallIcon } from '../../newIcons/plus-small.svg';
import { ReactComponent as RocketIcon } from '../../newIcons/rocket.svg';
import { ReactComponent as SettingsIcon } from '../../newIcons/settings.svg';
import { ReactComponent as TargetIcon } from '../../newIcons/target.svg';
import { ReactComponent as TrashBinIcon } from '../../newIcons/trash-bin.svg';
import { ReactComponent as TriangleDownIcon } from '../../newIcons/triangle-down.svg';
import { ReactComponent as UserIcon } from '../../newIcons/user.svg';
import { ReactComponent as BulbIcon } from '../../icons/bulb.svg';
import { ReactComponent as LogoSymbolIcon } from '../../newIcons/logo-symbol.svg';
import { ReactComponent as LogoSymbolAnimatedIcon } from '../../newIcons/logo-symbol-animated.svg';
import { ReactComponent as LogoWordMarkIcon } from '../../newIcons/logo-wordmark.svg';
import { ReactComponent as TableIcon } from '../../newIcons/table.svg';
import { ReactComponent as ChartDateIcon } from '../../newIcons/chart-date.svg';
import { ReactComponent as PieChartIcon } from '../../newIcons/pie-chart.svg';
import { ReactComponent as LineChartIcon } from '../../newIcons/line-chart.svg';
import { ReactComponent as DotChartIcon } from '../../newIcons/dot-chart.svg';
import { ReactComponent as VerticalBarsIcon } from '../../newIcons/vertical-bars.svg';
import { ReactComponent as WorkflowDataIcon } from '../../newIcons/workflow-data.svg';
import { ReactComponent as CohortIcon } from '../../newIcons/cohort.svg';
import { ReactComponent as CancelPlanIcon } from '../../icons/cancel-plan.svg';
import { ReactComponent as LockedIcon } from '../../newIcons/locked.svg';
import { ReactComponent as UnlockedIcon } from '../../newIcons/unlocked.svg';
import { ReactComponent as DownloadIcon } from '../../newIcons/download.svg';
import { ReactComponent as LinkIcon } from '../../newIcons/link.svg';
import { ReactComponent as ShareIcon } from '../../newIcons/share.svg';
import { ReactComponent as SqlIcon } from '../../newIcons/sql.svg';
import { ReactComponent as GoogleSheetsIcon } from '../../newIcons/google-sheets.svg';
import { ReactComponent as SlackIcon } from '../../newIcons/slack.svg';
import { ReactComponent as MailIcon } from '../../newIcons/mail.svg';
import { ReactComponent as ZapierIcon } from '../../newIcons/zapier.svg';
import { ReactComponent as S3Icon } from '../../newIcons/s3.svg';
import { ReactComponent as PlaneIcon } from '../../newIcons/plane.svg';
import { ReactComponent as MenuHorizontalIcon } from '../../newIcons/menu-horizontal.svg';
import { ReactComponent as RefreshIcon } from '../../newIcons/refresh.svg';
import { ReactComponent as MenuVerticalIcon } from '../../newIcons/menu-vertical.svg';
import { ReactComponent as StarIcon } from '../../newIcons/star.svg';
import { ReactComponent as SearchIcon } from '../../newIcons/search.svg';
import { ReactComponent as MinusIcon } from '../../newIcons/minus.svg';
import { ReactComponent as PowerIcon } from '../../newIcons/power.svg';
import { ReactComponent as CreditCardIcon } from '../../newIcons/credit-card.svg';
import { ReactComponent as StarFilledIcon } from '../../newIcons/star-filled.svg';
import { ReactComponent as ArrowLeftIcon } from '../../newIcons/arrow-left.svg';
import { ReactComponent as ArrowRightIcon } from '../../newIcons/arrow-right.svg';
import { ReactComponent as ArrowUpIcon } from '../../newIcons/arrow-up.svg';
import { ReactComponent as ArrowDownIcon } from '../../newIcons/arrow-down.svg';
import { ReactComponent as PostgresIcon } from '../../newIcons/postgres.svg';
import { ReactComponent as HerokuIcon } from '../../newIcons/heroku.svg';
import { ReactComponent as MySqlIcon } from '../../newIcons/my-sql.svg';
import { ReactComponent as SnowflakeIcon } from '../../newIcons/snowflake.svg';
import { ReactComponent as RedshiftIcon } from '../../newIcons/redshift.svg';
import { ReactComponent as PanoplyIcon } from '../../newIcons/panoply.svg';
import { ReactComponent as BigQueryIcon } from '../../newIcons/big-query.svg';
import { ReactComponent as SqlServerIcon } from '../../newIcons/sql-server.svg';
import { ReactComponent as MariaDbIcon } from '../../newIcons/maria-db.svg';
import { ReactComponent as MongoDbIcon } from '../../newIcons/mongo-db.svg';
import { ReactComponent as ErrorIcon } from '../../newIcons/error.svg';
import { ReactComponent as ChevronUpIcon } from '../../newIcons/chevron-up.svg';
import { ReactComponent as ChevronDownIcon } from '../../newIcons/chevron-down.svg';
import { ReactComponent as ChevronRightIcon } from '../../newIcons/chevron-right.svg';
import { ReactComponent as ChevronLeftIcon } from '../../newIcons/chevron-left.svg';
import { ReactComponent as BranchIcon } from '../../newIcons/branch.svg';
import { ReactComponent as EyeIcon } from '../../newIcons/eye.svg';
import { ReactComponent as ExpandIcon } from '../../newIcons/expand.svg';
import { ReactComponent as ExportIcon } from '../../newIcons/export.svg';
import { ReactComponent as LightBulbIcon } from '../../newIcons/light-bulb.svg';
import { ReactComponent as CopyIcon } from '../../newIcons/copy.svg';
import { ReactComponent as WebIcon } from '../../newIcons/web.svg';
import { ReactComponent as CloseSmallIcon } from '../../newIcons/close-small.svg';
import { ReactComponent as PlayIcon } from '../../newIcons/play.svg';
import { ReactComponent as IllustrationRocketIcon } from '../../newIcons/illustration-rocket.svg';
import { ReactComponent as IllustrationDashboardIcon } from '../../newIcons/illustration-dashboard.svg';
import { ReactComponent as IllustrationFreePlanIcon } from '../../newIcons/illustration-free-plan.svg';
import { ReactComponent as IllustrationPlusIcon } from '../../newIcons/illustration-plus.svg';
import { ReactComponent as IllustrationQuickIcon } from '../../newIcons/illustration-quick.svg';
import { ReactComponent as IllustrationProPlanIcon } from '../../newIcons/illustration-pro-plan.svg';
import { ReactComponent as IllustrationSecurityIcon } from '../../newIcons/illustration-security.svg';
import { ReactComponent as IllustrationUsageIcon } from '../../newIcons/illustration-usage.svg';
import { ReactComponent as IllustrationWhoopsIcon } from '../../newIcons/illustration-whoops.svg';
import { ReactComponent as IllustrationHelpIcon } from '../../newIcons/illustration-help.svg';
import { ReactComponent as IllustrationWavingHandIcon } from '../../newIcons/illustration-waving-hand.svg';
import { ReactComponent as IllustrationEnterpriseIcon } from '../../newIcons/illustration-enterprise.svg';
import { ReactComponent as SubscribeIcon } from '../../newIcons/subscribe.svg';
import { ReactComponent as CancelSubscribeIcon } from '../../newIcons/cancel-subscribe.svg';
import { ReactComponent as AnnotateIcon } from '../../newIcons/annotate.svg';
import { ReactComponent as InvitationEnvelopIcon } from '../../newIcons/invitation-envelope.svg';
import { ReactComponent as UserAddIcon } from '../../newIcons/user-add.svg';
import { ReactComponent as CodeIcon } from '../../newIcons/code.svg';
import { ReactComponent as SpinnerIcon } from '../../newIcons/spinner.svg';
import { ReactComponent as TestimonialTip } from '../../newIcons/testimonial-tip.svg';
import { ReactComponent as MicrosoftAzureIcon } from '../../newIcons/microsoft-azure.svg';
import { ReactComponent as AmazonAwsIcon } from '../../newIcons/amazon-aws.svg';
import { ReactComponent as GoogleCloudIcon } from '../../newIcons/google-cloud.svg';
import { ReactComponent as InfoIcon } from '../../newIcons/info.svg';
import { ReactComponent as WarningIcon } from '../../newIcons/warning.svg';
import { ReactComponent as HostingerIcon } from '../../newIcons/hostinger.svg';
import { ReactComponent as DigitalOceanIcon } from '../../newIcons/digital-ocean.svg';
import { ReactComponent as SupabaseIcon } from '../../newIcons/supabase.svg';
import { ReactComponent as LindoeIcon } from '../../newIcons/lindoe.svg';
import { ReactComponent as ManuallyExpandIcon } from '../../newIcons/manually-expand.svg';
import { ReactComponent as CheckboxControlSelectedIcon } from '../../newIcons/checkbox-control-selected.svg';
import { ReactComponent as CheckboxControlUnelectedIcon } from '../../newIcons/checkbox-control-unselected.svg';
import { ReactComponent as BookIcon } from '../../newIcons/book.svg';
import { ReactComponent as EyeClosedIcon } from '../../newIcons/eye-closed.svg';
import { ReactComponent as TeamIcon } from '../../newIcons/team.svg';
import { ReactComponent as SendInvitationEnvelopeIcon } from '../../newIcons/send-invitation-envelope.svg';
import { ReactComponent as FilterIcon } from '../../newIcons/filter.svg';
import { ReactComponent as TextIcon } from '../../newIcons/text.svg';
import { ReactComponent as UndoIcon } from '../../newIcons/undo.svg';
import { ReactComponent as RedoIcon } from '../../newIcons/redo.svg';
import { ReactComponent as ReceiptIcon } from '../../newIcons/receipt.svg';

export const NAME_TO_ICON = {
  'aws-s3': AWSS3Icon,
  close: CloseIcon,
  'dropdown-arrow-down': DropdownArrowDownIcon,
  edit: EditIcon,
  envelope: EnvelopeIcon,
  facebook: FacebookIcon,
  'floppy-disc': FloppyDiscIcon,
  ok: OkIcon,
  'open-window': OpenWindowIcon,
  linkedin: LinkedinIcon,
  'paper-plane': PaperPlaneIcon,
  person: PersonIcon,
  reddit: RedditIcon,
  'share-chain': ShareChainIcon,
  twitter: TwitterIcon,
  'vertical-dots': VerticalDotsIcon,
  warning: WarningIcon,
  question: QuestionIcon,
  'transparent-envelope': TransparentEnvelopeIcon,
  bulb: BulbIcon,

  // New icons
  'arrow-small-left': ArrowSmallLeftIcon,
  'arrow-small-right': ArrowSmallRightIcon,
  'bar-chart': BarChartIcon,
  'book-open': BookOpenIcon,
  'check-circle': CheckCircleIcon,
  'checkbox-selected': CheckboxSelectedIcon,
  'checkbox-unselected': CheckboxUnselectedIcon,
  'close-circle': CloseCircleIcon,
  compass: CompassIcon,
  dashboard: DashboardIcon,
  'drag-reorder': DragReorderIcon,
  document: DocumentIcon,
  floppy: FloppyIcon,
  pen: PenIcon,
  placeholder: PlaceholderIcon,
  plus: PlusIcon,
  'plus-small': PlusSmallIcon,
  rocket: RocketIcon,
  settings: SettingsIcon,
  target: TargetIcon,
  'trash-bin': TrashBinIcon,
  'triangle-down': TriangleDownIcon,
  user: UserIcon,
  'logo-symbol': LogoSymbolIcon,
  'logo-symbol-animated': LogoSymbolAnimatedIcon,
  'logo-wordmark': LogoWordMarkIcon,
  table: TableIcon,
  'chart-date': ChartDateIcon,
  'pie-chart': PieChartIcon,
  'line-chart': LineChartIcon,
  'dot-chart': DotChartIcon,
  'vertical-bars': VerticalBarsIcon,
  'workflow-data': WorkflowDataIcon,
  cohort: CohortIcon,
  'cancel-plan': CancelPlanIcon,
  locked: LockedIcon,
  unlocked: UnlockedIcon,
  download: DownloadIcon,
  link: LinkIcon,
  share: ShareIcon,
  sql: SqlIcon,
  'google-sheets': GoogleSheetsIcon,
  slack: SlackIcon,
  mail: MailIcon,
  zapier: ZapierIcon,
  s3: S3Icon,
  plane: PlaneIcon,
  'menu-horizontal': MenuHorizontalIcon,
  refresh: RefreshIcon,
  'menu-vertical': MenuVerticalIcon,
  star: StarIcon,
  search: SearchIcon,
  minus: MinusIcon,
  power: PowerIcon,
  'credit-card': CreditCardIcon,
  'star-filled': StarFilledIcon,
  'arrow-left': ArrowLeftIcon,
  'arrow-right': ArrowRightIcon,
  'arrow-up': ArrowUpIcon,
  'arrow-down': ArrowDownIcon,
  postgres: PostgresIcon,
  heroku: HerokuIcon,
  'my-sql': MySqlIcon,
  snowflake: SnowflakeIcon,
  redshift: RedshiftIcon,
  panoply: PanoplyIcon,
  'big-query': BigQueryIcon,
  'sql-server': SqlServerIcon,
  'maria-db': MariaDbIcon,
  'mongo-db': MongoDbIcon,
  error: ErrorIcon,
  'chevron-up': ChevronUpIcon,
  'chevron-down': ChevronDownIcon,
  'chevron-right': ChevronRightIcon,
  'chevron-left': ChevronLeftIcon,
  branch: BranchIcon,
  eye: EyeIcon,
  expand: ExpandIcon,
  export: ExportIcon,
  'light-bulb': LightBulbIcon,
  copy: CopyIcon,
  web: WebIcon,
  'close-small': CloseSmallIcon,
  play: PlayIcon,
  'illustration-rocket': IllustrationRocketIcon,
  'illustration-help': IllustrationHelpIcon,
  'illustration-waving-hand': IllustrationWavingHandIcon,
  'illustration-dashboard': IllustrationDashboardIcon,
  'illustration-free-plan': IllustrationFreePlanIcon,
  'illustration-plus': IllustrationPlusIcon,
  'illustration-quick': IllustrationQuickIcon,
  'illustration-pro-plan': IllustrationProPlanIcon,
  'illustration-security': IllustrationSecurityIcon,
  'illustration-usage': IllustrationUsageIcon,
  'illustration-whoops': IllustrationWhoopsIcon,
  'illustration-enterprise': IllustrationEnterpriseIcon,
  subscribe: SubscribeIcon,
  'cancel-subscribe': CancelSubscribeIcon,
  annotate: AnnotateIcon,
  'invitation-envelop': InvitationEnvelopIcon,
  'user-add': UserAddIcon,
  code: CodeIcon,
  spinner: SpinnerIcon,
  'testimonial-tip': TestimonialTip,
  'microsoft-azure': MicrosoftAzureIcon,
  'amazon-aws': AmazonAwsIcon,
  'google-cloud': GoogleCloudIcon,
  info: InfoIcon,
  hostinger: HostingerIcon,
  'digital-ocean': DigitalOceanIcon,
  supabase: SupabaseIcon,
  lindoe: LindoeIcon,
  'manually-expand': ManuallyExpandIcon,
  check: CheckIcon,
  'checkbox-control-selected': CheckboxControlSelectedIcon,
  'checkbox-control-unselected': CheckboxControlUnelectedIcon,
  book: BookIcon,
  'eye-closed': EyeClosedIcon,
  team: TeamIcon,
  'send-invitation-envelope': SendInvitationEnvelopeIcon,
  filter: FilterIcon,
  text: TextIcon,
  undo: UndoIcon,
  redo: RedoIcon,
  receipt: ReceiptIcon,
} as const;
